let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aoOfm")).then(() => parcelRequire('ebQs8'));